{
  "conversations": {
    "conversationsApp": "Samtaler-app",
    "locationId": "Lokations-ID",
    "idToken": "ID-token",
    "conversationRoutes": "Samtaleruter",
    "conversationProviders": "Udbydere af samtaler",
    "viewTheListOfConversation": "Vis Liste af samtale Tilpasset udbydere tilføjet til Konto her.",
    "logo": "Logo",
    "name": "Navn",
    "alias": "Alias",
    "type": "Type"
  }
}
